module.exports = __webpack_public_path__ + "static/img/Hussar_theme_face.1cbb834.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/Hussar_theme_face.webp
// module id = hCIO
// module chunks = 0